import React, { useState } from 'react';
import { Outlet, useLocation, useNavigate } from 'react-router-dom';
import { useAuth } from '../../context/AuthContext';
import SideNav from '../SideNav/SideNav';
import AuthenticatedNavbar from '../AuthenticatedNavbar/AuthenticatedNavbar';

function DashboardLayout() {
    const location = useLocation();
    const navigate = useNavigate();
    const { user, hasRole } = useAuth();
    const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
    const canAccessOdds = hasRole('ODDS_SCREEN');

    // Map routes to tab IDs
    const routeToTab = {
        '/discord': 'discord',
        '/manage-subscriptions': 'manage-subscriptions',
        '/snipe-feed': 'snipe-feed',
        '/results-tracker': 'results-tracker',
    };

    // Determine default tab based on Discord link status and roles
    const defaultTab = user?.discordLinked
        ? (canAccessOdds ? 'snipe-feed' : 'results-tracker')
        : 'discord';
    const activeTab = routeToTab[location.pathname] || defaultTab;

    const allMenuItems = [
        { id: 'discord', label: 'Discord', route: '/discord', showWhen: true },
        { id: 'manage-subscriptions', label: 'Manage Subscriptions', route: '/manage-subscriptions', showWhen: true },
        { id: 'snipe-feed', label: 'Snipe Feed', route: '/snipe-feed', showWhen: canAccessOdds },
        { id: 'results-tracker', label: 'Results Tracker', route: '/results-tracker', showWhen: true },
    ];

    // Filter menu items based on showWhen condition
    const menuItems = allMenuItems.filter(item => item.showWhen);

    const handleTabChange = (tabId) => {
        const menuItem = menuItems.find(item => item.id === tabId);
        if (menuItem) {
            navigate(menuItem.route);
            setIsMobileMenuOpen(false); // Close mobile menu after navigation
        }
    };

    const toggleMobileMenu = () => {
        setIsMobileMenuOpen(!isMobileMenuOpen);
    };

    return (
        <div className="min-h-screen bg-[#020817]">
            {/* Sidebar - positioned first for mobile overlay */}
            <SideNav 
                activeTab={activeTab}
                setActiveTab={handleTabChange}
                isMobileMenuOpen={isMobileMenuOpen}
            />

            {/* Mobile Menu Backdrop - only renders when menu is open */}
            {isMobileMenuOpen && (
                <div 
                    className="fixed inset-0 bg-black/60 md:hidden"
                    style={{ zIndex: 40 }}
                    onClick={() => setIsMobileMenuOpen(false)}
                    aria-hidden="true"
                />
            )}

            {/* Main Content Wrapper */}
            <div className="min-h-screen flex flex-col ml-0 md:ml-20">
                    {/* Header - Fixed at top */}
                    <AuthenticatedNavbar 
                        activeTab={activeTab} 
                        menuItems={menuItems}
                        toggleMobileMenu={toggleMobileMenu}
                        isMobileMenuOpen={isMobileMenuOpen}
                    />

                {/* Page Content - with top padding to account for fixed navbar */}
                <main className="flex-1 pt-[72px]">
                    <Outlet />
                </main>
            </div>
        </div>
    );
}

export default DashboardLayout;

